"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useImperativeHandle, useRef, forwardRef } from 'react';
import { ScrollShadow as HeroScrollShadow } from '@heroui/react';
export const ScrollShadow = forwardRef((props, ref) => {
    const heroScrollRef = useRef(null);
    const getScrollableElement = () => {
        if (!heroScrollRef.current)
            return null;
        const scrollableDiv = heroScrollRef.current.querySelector('div[style*="overflow"]');
        return scrollableDiv || heroScrollRef.current;
    };
    useImperativeHandle(ref, () => ({
        scrollToTop: (behavior = 'smooth') => {
            const scrollElement = getScrollableElement();
            if (scrollElement?.scrollTo) {
                scrollElement.scrollTo({ top: 0, behavior });
            }
        },
        scrollToBottom: (behavior = 'smooth') => {
            const scrollElement = getScrollableElement();
            if (scrollElement?.scrollTo) {
                scrollElement.scrollTo({ top: scrollElement.scrollHeight, behavior });
            }
        },
        scrollTo: (options) => {
            const scrollElement = getScrollableElement();
            if (scrollElement?.scrollTo) {
                scrollElement.scrollTo(options);
            }
        },
        getScrollPosition: () => {
            const scrollElement = getScrollableElement();
            return {
                top: scrollElement?.scrollTop || 0,
                left: scrollElement?.scrollLeft || 0
            };
        },
        isAtTop: () => {
            const scrollElement = getScrollableElement();
            return (scrollElement?.scrollTop || 0) <= 5;
        },
        isAtBottom: () => {
            const scrollElement = getScrollableElement();
            if (!scrollElement)
                return false;
            const { scrollTop, scrollHeight, clientHeight } = scrollElement;
            return scrollTop + clientHeight >= scrollHeight - 5;
        }
    }), []);
    return _jsx(HeroScrollShadow, { ref: heroScrollRef, ...props });
});
export default ScrollShadow;
//# sourceMappingURL=ScrollShadow.js.map